import { isProd } from './init.js';
import { toastError } from '../../functions/toast/toast.js';

// eslint-disable-next-line no-underscore-dangle
const isStorybook = !!window.__STORYBOOK_PREVIEW__;
const projectID = isProd ? 'caresend-prod' : 'caresend-dev';
const handleBindErrors = (errorMessage, firebaseRef) => {
    if (isProd)
        return;
    if (errorMessage.includes('permission_denied')) {
        return console.info(`You don't have permission to access the desired data. Firebase Ref: ${firebaseRef}`);
    }
    return toastError(errorMessage);
};

export { handleBindErrors, isStorybook, projectID };
